<script>
import { getBrands, deleteBrand } from '@/utils/brands'
import BrandModal from '@/components/modal/brand-modal.vue'

export default {

    components: {
        BrandModal
    },

    inject: ['setLoading'],

    data() {
        return {
            title: "Settings",
            text: "Administration",
            data: []
        }
    },

    mounted() {
        this.brands()
    },

    methods: {

        async brands() {

            this.setLoading(true)

            try {

                const response = await getBrands()
                this.data = response?.data?.data?.data || []

            } catch (error) {

                this.$swalToast(error.message, 'error')

            } finally {

                this.setLoading(false)

            }

        },

        // DELETE CONFIRM
        confirmDelete(id) {

            this.$swal({
                title: "Confirm Delete",
                text: "You want to delete this brand!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes Delete",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6"
            }).then((result) => {

                if (result.isConfirmed) {
                    this.removeBrand(id)
                }

            })

        },

        // DELETE API
        async removeBrand(id) {

            this.setLoading(true)

            try {

                const response = await deleteBrand(id)

                this.$swalToast(response.data.message)

                this.brands()

            } catch (error) {

                this.$swalToast(error.message, 'error')

            } finally {

                this.setLoading(false)

            }

        }

    }

}
</script>


<template>

    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <div class="page-wrapper">

        <div class="content">

            <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                <breadcrumb :title="title" :text="text" text1="Brands" />
            </div>

            <settings-tab></settings-tab>

            <div class="row">

                <others-sidebar></others-sidebar>

                <div class="col-xl-9">

                    <div class="card">

                        <div class="card-header d-flex justify-content-between">

                            <h5>Brands</h5>

                            <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#brand_modal"
                                @click="$refs.brandModal.open()">

                                <i class="ti ti-circle-plus me-2"></i>
                                Add Brand

                            </button>

                        </div>

                        <div class="card-body card-table-wrapper">

                            <div class="table-responsive">

                                <table class="card-table">

                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Code</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr v-for="(row, index) in data" :key="row.id">

                                            <td>{{ index + 1 }}</td>

                                            <td>{{ row.name }}</td>

                                            <td>
                                                <span class="badge bg-info text-white">
                                                {{ row.code }}
                                                </span>
                                            </td>

                                            <td>

                                                <div class="dropdown">

                                                    <button class="btn btn-icon btn-sm rounded-circle"
                                                        data-bs-toggle="dropdown">
                                                        <i class="ti ti-dots-vertical"></i>
                                                    </button>

                                                    <ul class="dropdown-menu dropdown-menu-end">

                                                        <li>
                                                            <a class="dropdown-item" data-bs-toggle="modal"
                                                                data-bs-target="#brand_modal"
                                                                @click="$refs.brandModal.open(row)">
                                                                <i class="ti ti-edit me-2"></i>
                                                                Edit
                                                            </a>
                                                        </li>

                                                        <li>
                                                            <a class="dropdown-item text-danger"
                                                                href="javascript:void(0)"
                                                                @click="confirmDelete(row.id)">
                                                                <i class="ti ti-trash me-2"></i>
                                                                Delete
                                                            </a>
                                                        </li>

                                                    </ul>

                                                </div>

                                            </td>

                                        </tr>

                                        <tr v-if="!data.length">
                                            <td colspan="3" class="text-center text-muted p-3">
                                                No brands found
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

        <app-footer></app-footer>

    </div>

    <brand-modal ref="brandModal" @updated="brands" />

</template>